const categoriesData = 
    [ 
        {name: 'aaa', icon: 'happy-outline'},
        {name: 'bbb', icon: 'happy-outline'},
        {name: 'ccc', icon: 'happy-outline'},
        {name: 'ddd', icon: 'happy-outline'},
        {name: 'eee', icon: 'happy-outline'},
        {name: 'fff', icon: 'happy-outline'},
        {name: 'ggg', icon: 'happy-outline'},
        {name: 'hhh', icon: 'happy-outline'},
        {name: 'iii', icon: 'happy-outline'},
        {name: 'jjj', icon: 'happy-outline'}
    ];

    
export default categoriesData;